import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-6 col-sm container"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = { class: "row justify-content-end mt-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "row justify-content-end mt-3" }
const _hoisted_10 = { class: "row mt-5" }
const _hoisted_11 = { class: "col text-right" }
const _hoisted_12 = {
  key: 1,
  class: "two-fa-container"
}
const _hoisted_13 = {
  key: 0,
  class: "two-fa-steps"
}
const _hoisted_14 = {
  key: 1,
  class: "two-fa-steps"
}
const _hoisted_15 = {
  key: 0,
  class: "text-center"
}
const _hoisted_16 = {
  key: 1,
  class: "text-center"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = {
  class: "code-inputs",
  style: {"margin-top":"24px"}
}
const _hoisted_21 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_22 = { style: {"display":"flex","flex-direction":"column","row-gap":"4px","margin-top":"12px"} }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { class: "row justify-content-center" }
const _hoisted_25 = { class: "d-flex justify-content-end my-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_PasswordForgetDialog = _resolveComponent("PasswordForgetDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.verifyPage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "col mt-3",
                  style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2 })
                }, " ログイン ", 4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-4" }, "社員番号", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "col-8 input-frame",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userId) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.userId]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-4" }, "パスワード", -1)),
                _createVNode(_component_PasswordInput, {
                  class: "col-8",
                  password: _ctx.password,
                  "onUpdate:password": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                }, null, 8, ["password"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "col-8 btn btn-primary",
                  disabled: !_ctx.canClickLogin(),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickLogin && _ctx.onClickLogin(...args)))
                }, " ログイン ", 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock("div", {
                  key: _ctx.errorFlashSeq,
                  class: _normalizeClass(["col-8 warning-message text-center", { 'flash-box': _ctx.warningMessage }])
                }, _toDisplayString(_ctx.warningMessage), 3))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickPWForgetLink && _ctx.onClickPWForgetLink(...args)), ["prevent"])),
                    class: _normalizeClass({ 'pulse-nudge': _ctx.forgetLinkPulseActive }),
                    onAnimationend: _cache[4] || (_cache[4] = ($event: any) => (_ctx.forgetLinkPulseActive = false))
                  }, "パスワードを忘れた", 34)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (!_ctx.isAuthApp && _ctx.selected2faOpt === 'auth_app')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[10] || (_cache[10] = [
                    _createStaticVNode("<h3 class=\"text-center\" style=\"font-weight:600;\" data-v-b1f91b54> 二要素認証によるアカウントの保護 </h3><p class=\"text-center\" style=\"margin-bottom:48px;\" data-v-b1f91b54> アカウントを保護するために、Authenticatorアプリを設定することをお勧めします。以下の手順に従ってください： </p><p style=\"padding:0;margin:0;font-weight:600;margin-bottom:8px;\" data-v-b1f91b54> 1. Google AuthenticatorやAuthyなどの認証アプリをダウンロードする。 </p><p style=\"padding:0;margin:0;font-weight:600;margin-bottom:8px;\" data-v-b1f91b54> 2. アプリを使って下記のQRコードをスキャンする。 </p><p style=\"padding:0;margin:0;font-weight:600;margin-bottom:8px;\" data-v-b1f91b54> 3. アプリが生成した6桁のコードを入力する。 </p>", 5)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.isAuthApp || _ctx.selected2faOpt === 'email')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[11] || (_cache[11] = _createElementVNode("h3", {
                      class: "text-center",
                      style: {"font-weight":"600","margin-bottom":"24px"}
                    }, " 検証コード ", -1)),
                    (_ctx.selected2faOpt === 'auth_app')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, " 認証アプリに表示されているコードを入力する。 "))
                      : _createCommentVNode("", true),
                    (_ctx.selected2faOpt === 'email')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, " あなたの電子メールに送信された検証コードを入力します。 "))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (
            _ctx.selected2faOpt === 'auth_app' &&
            !_ctx.isAuthApp &&
            _ctx.qrCode?.file_data !== ''
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: 'data:image/jpeg;base64,' + _ctx.qrCode?.file_data
                    }, null, 8, _hoisted_18)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isAuthApp && _ctx.selected2faOpt === 'auth_app')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("div", { style: {"width":"100%","height":"1px","background-color":"black","margin-top":"12px","margin-bottom":"12px"} }, null, -1),
                    _createElementVNode("p", { class: "text-center" }, " 認証アプリを開き、QRコードまたは以下のコードを貼り付けてください。 ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.digits, (digit, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: index,
                    type: "text",
                    class: "digit-box",
                    maxlength: "1",
                    "onUpdate:modelValue": ($event: any) => ((_ctx.digits[index]) = $event),
                    onInput: ($event: any) => (_ctx.onInput(index, $event)),
                    onKeydown: _withKeys(($event: any) => (_ctx.onBackspace(index, $event)), ["backspace"]),
                    ref_for: true,
                    ref: (el) => _ctx.assignInputRef(el, index)
                  }, null, 40, _hoisted_21)), [
                    [_vModelText, _ctx.digits[index]]
                  ])
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.verify2FaHandler && _ctx.verify2FaHandler(...args))),
                  class: "btn btn-primary"
                }, " 確認する "),
                (_ctx.selected2faOpt === 'email' || !_ctx.isAuthApp)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args))),
                      class: "btn text-primary",
                      style: {"font-weight":"700"}
                    }, " コード再送 "))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showResendCodeMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("p", { style: {"color":"green"} }, "新しいコードを送信しました", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"width":"240px","height":"1px","background-color":"black","margin-top":"12px","margin-bottom":"12px"} }, null, -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", {
                    class: "w-full mt-4",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelVerify && _ctx.cancelVerify(...args))),
                    style: {"color":"#007bff","cursor":"pointer"}
                  }, " キャンセル ")
                ])
              ])
            ]))
      ])
    ]),
    _createVNode(_component_PasswordForgetDialog, {
      show: _ctx.showPWForgetDialog,
      "close-dialog": _ctx.closePWForgetDialog
    }, null, 8, ["show", "close-dialog"])
  ], 64))
}